<template>
<div>
    <pt-hospital-form ref="form" class="pt-hospital-form__withData"  :company="company" :rolesList="rolesList"
  :hospitalDetail="hospitalDetail" :isEdit="isEdit"></pt-hospital-form>
</div>
</template>

<script>
import PtHospitalForm from './form'
export default {
  name: 'pt-hospital-form__withData',
  components: {
    'pt-hospital-form': PtHospitalForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  props: {
    userLogin: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      company: [],
      rolesList: [],
      hospitalDetail: {},
      is_dialog: false,
      password: '',
      formValue: {}
    }
  },
  methods: {
    getHospitalDetail () {
      this.$emit('detailLoading', true)
      this.$store.dispatch('getHospitalDetail', this.$route.params.id).then(res => {
        this.$emit('detailLoading', false)
        this.hospitalDetail = res
      }).catch(err => {
        this.$emit('detailLoading', false)
        this.$message.error(err || '获取医院详情失败')
      })
    },
    submit () {
      this.form.validate().then(formValue => {
        if (!this.isEdit) {
          this.createHospital(formValue)
        } else {
          this.updateHospital(formValue)
        }
      })
    },
    createHospital (data) {
      this.$emit('submitLoading', true)
      this.$store.dispatch('createHospital', data).then(res => {
        this.$emit('submitLoading', false)
        this.$message.success('新建医院成功')
        history.go(-1)
      }).catch(errorMessage => {
        this.$emit('submitLoading', false)
        this.$message.error(errorMessage || '新建医院失败')
      })
    },
    updateHospital (data) {
      this.$emit('submitLoading', true)
      this.$store.dispatch('updateHospital', data).then(res => {
        this.$emit('submitLoading', false)
        this.$message.success('编辑医院成功')
        history.go(-1)
      }).catch(err => {
        this.$emit('submitLoading', false)
        this.$message.error(err || '编辑医院失败')
      })
    },
    getCompanyList () {
      let data = {
        pageableParam: {
          page: 0,
          size: 9999
        },
        type: 'BRANCH'
      }
      this.$store.dispatch('getBranchCompanyList', data).then(res => {
        var newArr = []
        res.data.forEach(ele => {
          var obj = {}
          obj.value = ele.id
          obj.label = ele.fullName
          newArr.push(obj)
        })
        this.company = newArr
      }).catch(err => {
        this.$message.error(err || '获取分/子公司列表失败')
      })
    }
  },
  created () {
    this.getCompanyList()
    if (this.isEdit) {
      this.getHospitalDetail()
    }
  }
}
</script>
